import React, { useState, useEffect } from 'react';
import { format, addDays, formatISO, addMonths } from 'date-fns';

import { passBusinessDays } from '@/types/subscriptions/subscription';
import { REMOTEST_MONTHS } from '@/constants';
import { StartsOnView } from '@/components/pages/Subscription/Presentation/Form/Field/StartsOn/StartsOnView';
import { normalizeStartsOn } from '@/store/organization/subscription/utils';

const nowDate = new Date();
const minDate = new Date(formatISO(addDays(nowDate, passBusinessDays())));
const maxDate = new Date(formatISO(addMonths(nowDate, REMOTEST_MONTHS)));

type Props = {
  value: string;
  dateFormat: string;
  error?: string;
  onChange: (value: string, touched: boolean) => void;
};

export const StartsOnContainer: React.FC<Props> = ({
  value,
  dateFormat,
  error,
  onChange,
}) => {
  const [initialized, setInitialized] = useState(false);
  const [startsOn, setStartsOn] = useState<Date>(
    value ? new Date(normalizeStartsOn(value)) : minDate,
  );

  useEffect(() => {
    onChange(format(startsOn, dateFormat), false);
    setInitialized(true);
  }, [dateFormat, onChange, startsOn]);

  useEffect(() => {
    if (initialized) {
      setStartsOn(startsOn);
      onChange(format(startsOn, dateFormat), true);
    }
  }, [startsOn, dateFormat, initialized, onChange]);

  const childProps = {
    minDate,
    maxDate,
    dateFormat,
    error,
    startsOn,
    setStartsOn,
  };
  return <StartsOnView {...childProps} />;
};
